export { RecentSearches } from "./RecentSearches";

